<mat-toolbar color="primary">

  <mat-toolbar-row>
    <button mat-icon-button (click)="onToggleSidenav()"  *ngIf="isUserAuthenticated">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Walletron Portal</span>
    <span class="example-spacer"></span>
    <div class="version-info">
      {{appVerion}} 
    </div>
    <span class="example-spacer"></span>
    <img src="../assets/images/ACI-Horizontal-White.png" height="40%">
    <span class="example-spacer"></span>

    <span class="example-spacer">
    </span>

    <span class="example-spacer">
      @if (!isProdEnvironment) {
        <h4 class="text-center env-banner">{{environmentBanner}}</h4>        
      }
    </span>

    <span class="example-spacer">
    </span>

    <div class="btn-group btn-group-toggle" data-toggle="buttons">

      @if (isUserAuthenticated && hasPrivilege('PRIV_PORTAL_HOME_PAGE')) {
        <button pButton type="button" label="Home" icon="pi pi-home" (click)="navigateMenu('home')" 
          class="p-button-raised p-button-rounded">
        </button>
      }

      @if (isUserAuthenticated && hasAllPrivileges(['PRIV_VP_JOB_MONITOR_VIEW','PRIV_VP_EVENT_OCCURANCE_VIEW'])) {  
        <button pButton type="button" label="Monitor" icon="pi pi-camera" (click)="navigateMenu('monitoring')"
          class="p-button-raised p-button-rounded">
        </button>
      }

      @if (isUserAuthenticated && hasPrivilege('PRIV_WAL_ACCOUNT_INFO')) {
        <button pButton type="button" label="Acct Info" icon="pi pi-info-circle" (click)="navigateMenu('accountInfo')"
          class="p-button-raised p-button-rounded">
        </button>
      }

      @if (isUserAuthenticated && hasAllPrivileges(['PRIV_VP_STATS','PRIV_VP_ARTIFACT_GENERATOR'])) {  
        <button pButton type="button" label="Enrollments" icon="pi pi-user-plus" (click)="navigateMenu('enrollments')"
          class="p-button-raised p-button-rounded">
        </button>
      }

      @if (isUserAuthenticated && hasPrivilege('PRIV_VP_ACCT_CSR')) {
        <button pButton type="button" label="CSR" icon="pi pi-check-circle" (click)="navigateMenu('csr-account')"
          class="p-button-raised p-button-rounded">
        </button>
      }

      @if (isUserAuthenticated && hasAnyPrivilege(['PRIV_WA_USER_MODIFY','PRIV_WA_USER_VIEW'])) {
        <button pButton type="button" label="Users" icon="pi pi-users" (click)="navigateMenu('portalUsers')"
          class="p-button-raised p-button-rounded">
        </button>
      }

      <button pButton type="button" label="Sign Out" icon="pi pi-sign-out" (click)="navigateMenu('logout')"
       class="p-button-raised p-button-rounded">
      </button>

    </div>

  </mat-toolbar-row>

</mat-toolbar>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="idle-session"></p-confirmDialog>



